
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Asset } from '../helpers/types'

@Component({
  template: `
  <div class="downloads">
    <div class='download-list-section full-width-mobile' v-for='(value, key, index) in groupAssets' :key='key'>
      <expand-item v-if="onlyGroupWithName.length === 0" :title='key' :initial-open="index === 0">
        <div class='download-list'>
          <download-item
            v-for='(item, index) in value'
            :href='item.url'
            :title='getNameWithoutType(item.name, item.originalFilename)'
            :originalFilename='item.originalFilename'
            :image-url='item.thumbnailUrl'
            :key='key + item.name + index'
            :type='getType(item.name)'
          />
        </div>
      </expand-item>
      <div v-else class='download-list'>
        <download-item
          v-for='(item, index) in value'
          :href='item.url'
          :title='getNameWithoutType(item.name, item.originalFilename)'
          :originalFilename='item.originalFilename'
          :image-url='item.thumbnailUrl'
          :key='key + item.name + index'
          :type='getType(item.name)'
        />
      </div>
    </div>
  </div>
  `
})
export default class DownloadList extends Vue {
  @Prop() assets!: Asset[]
  @Prop({ default: () => [] }) withoutGroupWithName: string[]
  @Prop({ default: () => [] }) onlyGroupWithName: string[]

  get groupAssets(): any {
    const test =  this.assets.reduce((acc, asset: Asset) => {
      const key: string = asset.group
      if (this.onlyGroupWithName.length > 0 && !this.onlyGroupWithName.includes(key)) {
        return acc;
      }

      if (this.withoutGroupWithName.includes(key)) {
        return acc
      }

      if(!acc[key]) acc[key] = []

      acc[key].push(asset)
      return acc
    }, {} as any)
    return test
  }

  getType(name: string): string {
    const type = name.split('.').pop()
    return type ? type : ''
  }

  getNameWithoutType(name: string, originalName: string | null): string {
    const x = originalName ?? name;

    return x.substring(0, x.lastIndexOf('.')) || x;
  }
}
